<template>
  <Layout>
    <customer-edit-modal
        id="customer-edit-modal"
        :key="`customer-edit-modal`"
        ref="customer_edit_modal"
        :modal-title="`EDIT PELANGGAN`"
        @updated="fetchModel"
    ></customer-edit-modal>
    <Loader :loading="loading || updating" no-axios>
      <div v-if="(model || {}).id">
        <a @click="$router.back()">
          <div class="container-title d-flex align-items-center">
            <span class="me-2">
              <svg
                  fill="none"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M6.875 15.3001L0.275 8.70008C0.175 8.60008 0.104 8.49175 0.0619998 8.37508C0.0206665 8.25842 0 8.13342 0 8.00008C0 7.86675 0.0206665 7.74175 0.0619998 7.62508C0.104 7.50842 0.175 7.40008 0.275 7.30008L6.875 0.700082C7.05833 0.516749 7.28733 0.420749 7.562 0.412083C7.83733 0.404083 8.075 0.500082 8.275 0.700082C8.475 0.883416 8.57933 1.11242 8.588 1.38708C8.596 1.66242 8.5 1.90008 8.3 2.10008L3.4 7.00008H14.575C14.8583 7.00008 15.096 7.09575 15.288 7.28708C15.4793 7.47908 15.575 7.71675 15.575 8.00008C15.575 8.28342 15.4793 8.52075 15.288 8.71208C15.096 8.90408 14.8583 9.00008 14.575 9.00008H3.4L8.3 13.9001C8.48333 14.0834 8.57933 14.3167 8.588 14.6001C8.596 14.8834 8.5 15.1167 8.3 15.3001C8.11667 15.5001 7.88333 15.6001 7.6 15.6001C7.31667 15.6001 7.075 15.5001 6.875 15.3001Z"
                    fill="#6C7589"
                />
              </svg>
            </span>
            {{ lodash.upperCase($t('{something} Details', {something: lodash.upperCase($t('customers.singular'))})) }}
          </div>
        </a>
        <b-card>
          <div class="row">
            <div class="col-md-11">
              <div class="row">
                <div class="col-md-6">
                  <div class="">
                    <div class="label">
                      {{ lodash.upperFirst($t('customers.code')) }}
                    </div>
                    <div class="value">
                      {{ model.code || '-' }}
                    </div>
                  </div>
                  <div class="">
                    <div class=" label">
                      {{ lodash.upperFirst($t('customers.type')) }}
                    </div>
                    <div class="value">
                      {{ customerTypesText }}
                    </div>
                  </div>
                  <div class="">
                    <div class="label">
                      {{ lodash.upperFirst($t('customers.group_name')) }}
                    </div>
                    <div class="value">
                      {{ odooObligorGroupName }}
                    </div>
                  </div>
                  <div class="">
                    <div class="label">
                      {{ lodash.startCase(`${$t('customers.name')} ${$t('customers.types.partner')}`) }}
                    </div>
                    <div class="value">
                      {{ model.name || '-' }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="">
                    <div class="label">
                      {{  $t('customers.phone_number_abbreviation') }}
                    </div>
                    <div class="value">
                      {{ model.phone_number || '-' }}
                    </div>
                  </div>
                  <div class="">
                    <div class="label">
                      {{ lodash.startCase($t('customers.total_person')) }}
                    </div>
                    <div class="value">
                      {{ totalPerson }}
                    </div>
                  </div>
                  <div class="">
                    <div class="label">
                      {{ lodash.startCase($t('odoo_partners.singular')) }}
                    </div>
                    <div class="value">
                      {{ odooPartnerName }}
                    </div>
                  </div>
                  <div class="label">
                    {{ lodash.startCase($t('customers.customer_status')) }}
                  </div>
                  <div class="value">
                    <b-badge v-if="model.active" variant="success">{{
                        lodash.upperFirst($t('customers.active'))
                      }}
                    </b-badge>
                    <b-badge v-else variant="danger">{{ lodash.upperFirst($t('customers.inactive')) }}</b-badge>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1" v-if="!denyEdit">
              <div class="float-end">
                <b-button variant="primary" @click="$refs.customer_edit_modal.edit(model.id)">Ubah</b-button>
              </div>
            </div>
          </div>
          <hr>
          <div class="border overflow-hidden rounded mb-3">
            <b-table
                :fields="limitObligorFields"
                :items="limitObligorItems"
                borderless
                hover
                responsive
                show-empty
            >
              <template #cell()="data">
                <template v-if="data.field.component">
                  <component
                      :is="data.field.component"
                      v-bind="{ item: data.item }"
                      v-on="data.field['componentListeners'] || {}"
                  ></component>
                </template>
                <template v-else>{{ data.value }}</template>
              </template>
              <template #cell(used_amount_ratio)="{value}">
                <b-badge :variant="usedAmountRatioVariant(value)">
                  {{ percentageFormatter(value) }}
                </b-badge>
              </template>
              <template #cell(max_days_past_due_in_90_days)="{value}">
                <b-badge class="d-block" :variant="daysPastDueVariant(value)">
                  {{ value || '-' }}
                </b-badge>
              </template>
              <template #empty="scope">
                <p class="my-auto mx-auto text-center text-muted">
                  {{ lodash.upperFirst($t('customers.there_is_no_limit')) }}
                </p>
              </template>
            </b-table>
          </div>
        </b-card>
        <b-card>
          <h2 class="custom-title">{{
              lodash.startCase($t('{something} list', {something: $t('banks.singular')}))
            }}</h2>
          <div class="border overflow-hidden rounded mb-3">
            <b-table
                :fields="bankAccountFields"
                :items="bankAccountItems"
                borderless
                hover
                responsive
                show-empty
            >
              <template #cell()="data">
                <template v-if="data.field.component">
                  <component
                      :is="data.field.component"
                      v-bind="{ item: data.item }"
                      v-on="data.field['componentListeners'] || {}"
                  ></component>
                </template>
                <template v-else>{{ data.value }}</template>
              </template>
              <template #empty="scope">
                <p class="my-auto mx-auto text-center text-muted">
                  {{ lodash.upperFirst($t('bank_accounts.there_is_no_bank_account')) }}
                </p>
              </template>
              <template #cell(active)="data">
                <b-form-checkbox
                    v-model="data.item.active"
                    button-variant="success"
                    switch
                    @change="onBackActiveChange(data.item, $event)"
                    :disabled="denyEdit"
                ></b-form-checkbox>
              </template>
            </b-table>
          </div>
        </b-card>
        <b-tabs
            class="mb-4"
            content-class="border-tab-content"
            nav-class="nav-address"
        >
          <b-tab
              v-if="farms.length"
              class="px-3 py-2 bg-white border-tab-content"
              :title="`${lodash.startCase($t('{something} Details', {something: $t('customers.address')}))} Tambak`"
          >
            <h2 class="custom-title">
              {{ lodash.startCase($t('{something} Details', {something: $t('customers.address')})) }}</h2>
            <template v-for="(farm, index) in model.farms">
              <customer-office-show
                  v-bind:key="farm.id"
                  :office="farm"
                  customer_type="farmer"
              ></customer-office-show>
              <hr
                  v-if="index < (model.farms || []).length - 1"
                  v-bind:key="farm.id"
                  class="mb-4"
              />
            </template>
          </b-tab>
          <b-tab
              v-if="model.processing.id"
              class="px-3 py-2 bg-white border-tab-content"
              :title="`${lodash.startCase($t('{something} Details', {something: $t('customers.address')}))} Pabrik`"
          >
            <h2 class="custom-title"
            >
              {{ lodash.startCase($t('{something} Details', {something: $t('customers.address')})) }}</h2>
            <customer-office-show
                :office="model.processing"
                customer_type="processing"
            ></customer-office-show>
          </b-tab>
          <b-tab
              v-if="model.partner.id || model.lcs.id || model.brs.id"
              class="px-3 py-2 bg-white border-tab-content"
              :title="`${lodash.startCase($t('{something} Details', {something: $t('customers.address')}))} Mitra`"
          >
            <h2 class="custom-title">
              {{ lodash.startCase($t('{something} Details', {something: $t('customers.address')})) }}</h2>
            <customer-office-show
                v-if="model.partner.id"
                :office="model.partner"
                customer_type="partner"
            ></customer-office-show>
            <hr
                v-if="model.lcs.id && model.partner.id"
                class="mb-4"
            />
            <customer-office-show
                v-if="model.lcs.id"
                :office="model.lcs"
                customer_type="lcs"
            ></customer-office-show>
            <hr
                v-if="model.brs.id && (model.partner.id || model.lcs.id)"
                class="mb-4"
            />
            <customer-office-show
                v-if="model.brs.id"
                :office="model.brs"
                customer_type="brs"
            ></customer-office-show>
          </b-tab>
        </b-tabs>
        <div class="row col-md-6 mb-1">
          <div class="col-md-3 label-auditable fw-bold font-size-10">
            {{ lodash.startCase(this.$t(`CreatedBy`)) }}
          </div>
          <div class="col-md-9 label-auditable font-size-10">
            {{ creatorName }}
          </div>
        </div>
        <div class="row col-md-6 mb-3">
          <div class="col-md-3 label-auditable fw-bold font-size-10">
            {{ lodash.startCase(this.$t(`CreatedAt`)) }}
          </div>
          <div class="col-md-9 label-auditable font-size-10">
            {{ createdAt }}
          </div>
        </div>
        <div class="row col-md-6 mb-1">
          <div class="col-md-3 label-auditable fw-bold font-size-10">
            {{ lodash.startCase(this.$t(`UpdatedBy`)) }}
          </div>
          <div class="col-md-6 label-auditable font-size-10">
            {{ updaterName }}
          </div>
        </div>
        <div class="row col-md-6 mb-3">
          <div class="col-md-3 label-auditable fw-bold font-size-10">
            {{ lodash.startCase(this.$t(`UpdatedAt`)) }}
          </div>
          <div class="col-md-9 label-auditable font-size-10">
            {{ updatedAt }}
          </div>
        </div>
        <!--        </b-card>-->
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelShow from "../models/show";
import Row from "@/components/models/show/custom-row";
import Loader from "@/components/widgets/loader";
import SegmentedButton from "@/components/segmented-button";
import CustomerOfficeShow from "@/components/forms/customer/customer-office-show";
import Swal from "sweetalert2";
import CustomerEditModal from '@/components/modals/customer-edit'
import numeral from "numeral";
import { daysPastDueVariant, usedAmountRatioVariant } from "@/helpers/ui/badgeVariants";
// import { serialize } from "object-to-formdata";

export default {
  extends: ModelShow,
  page: {
    title: "Detail Customers",
  },
  components: {
    Loader,
    SegmentedButton,
    CustomerOfficeShow,
    CustomerEditModal,
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("customers.singular"));
      },
    },
    resourceRoute: {default: "customers"},
    modelVariable: {default: "customer"},
    denyEdit: {
      type: Boolean,
      default() {
        return !this.$auth.hasPermissionTo("customers.edit");
      },
    },
    denyDelete: {type: Boolean, default: true},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: Row,
            },
          ],
        };
      },
    },
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t("customers.plural")),
      segmentedButtons: [],
      updating: false,
      numeral: numeral,
      // segmentedButtons(){
      //   return this.model.type.map((customer_type) => ({ text: this.$t(`customers.types.${customer_type}`), value: customer_type }))
      // }
    };
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    customerTypesText() {
      return this.model.types.map((customer_map) => this.$t(`customers.types.${customer_map}`)).join(", ")
    },
    createdAt() {
      return this.$moment.utc(this.model.created_at).local().format('lll')
    },
    updatedAt() {
      return this.$moment.utc(this.model.updated_at).local().format('lll')
    },
    odooObligorGroupName() {
      return this.model?.odoo_res_partner?.odoo_obligor_limit?.odoo_obligor_limit_group.name ?? '-'
    },
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t("customers.plural")),
          href: "/customers",
        },
        {
          text:
              this.model && this.model.id
                  ? this.model["name"]
                  : this.$route.params.key,
          href: `/customers/${this.$route.params.key}`,
          active: true,
        },
      ];
    },
    modelMapped() {
      let vm = this;
      return this.lodash.isEmpty(this.model)
          ? []
          : [
            {
              key: this.lodash.upperFirst(
                  this.$t(`${this.resourceRoute}.code`)
              ),
              value: this.model.code,
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.upperFirst(
                  this.$t(`${this.resourceRoute}.name`)
              ),
              value: this.model.name,
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.upperFirst(
                  this.$t(`${this.resourceRoute}.type`)
              ),
              item: this.model.types,
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              value: {
                props: {item: {type: String, default: ""}},
                computed: {
                  types() {
                    return this.item
                        .map((type) => {
                          return this.$t(`customers.types.${type}`);
                        })
                        .join(", ");
                  },
                },
                template: `
                  <div>{{ types }}</div>`,
              },
            },
            {
              key: this.lodash.upperFirst(
                  this.$t(`${this.resourceRoute}.address`)
              ),
              item: this.model.address.street,
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              value: {
                props: {item: {type: String, default: ""}},
                template: `<span v-html="item || '-'"></span>`,
              },
            },
            {
              key: this.lodash.upperFirst(
                  this.$t(`${this.resourceRoute}.active`)
              ),
              value: this.lodash.upperFirst(
                  this.$t(`${this.resourceRoute}.actives.${this.model.active}`)
              ),
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.upperFirst(
                  this.$t(`${vm.resourceRoute}.bank.text`)
              ),
              item: this.model.bank_accounts,
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "bank",
                        label: this.lodash.startCase(
                            this.$t(`${vm.resourceRoute}.bank.bank_name`)
                        ),
                      },
                      {
                        key: "account_number",
                        label: this.lodash.startCase(
                            this.$t(`${vm.resourceRoute}.bank.account_number`)
                        ),
                      },
                      {
                        key: "name",
                        label: this.lodash.startCase(
                            this.$t(`${vm.resourceRoute}.bank.account_name`)
                        ),
                      },
                      {
                        key: "active",
                        label: this.lodash.startCase(
                            this.$t(`${vm.resourceRoute}.active`)
                        ),
                      },
                    ];
                  },
                },
                template:
                    '<b-table :fields="fields" :items="item">' +
                    '<template #cell(bank)="data">{{ data.value.name }}</template>' +
                    '<template #cell(active)="data">{{ lodash.upperFirst($t(`customers.actives.${data.value}`)) }}</template>' +
                    "</b-table>",
              },
            },
            {
              key: this.lodash.upperFirst(this.$t(`models.description`)),
              item: this.model.description,
              value: {
                props: {item: {type: String, default: ""}},
                template: `<span v-html="item || '-'"></span>`,
              },
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
          ];
    },
    bankAccountItems() {
      return this.model.bank_accounts.map((bank_account) => ({
        ...bank_account,
      }));
    },
    bankAccountFields() {
      return [
        {
          key: "bank.name",
          label: "Nama Bank",
        },
        {
          key: "account_number",
          label: "Nomor Rekening",
        },
        {
          key: "name",
          label: "Nama Pemilik",
        },
        {
          key: "active",
          label: "Aktif",
        },
      ];
    },
    limitObligorItems() {
      let limit = this.model?.odoo_res_partner?.odoo_obligor_limit
      let limitGroup = limit?.odoo_obligor_limit_group
      let limitAmount = limitGroup?.limit_amount || 0
      let usedAmount = typeof limit?.used_amount === 'number' ? limit.used_amount : 0

      return [{
        limit_amount: limitGroup?.limit_amount,
        used_amount: usedAmount,
        available_amount: limitGroup?.available_amount,
        used_amount_ratio: limitAmount > 0 ? usedAmount / limitAmount : 0,
        max_days_past_due_in_90_days: this.model?.odoo_res_partner?.max_days_past_due_in_90_days,
      }]
    },
    limitObligorFields() {
      return [
        {
          key: "limit_amount",
          label: this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.limit')),
          formatter: this.currencyFormatter,
        },
        {
          key: "used_amount",
          label: this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.usage')),
          formatter: this.currencyFormatter,
        },
        {
          key: "available_amount",
          label: this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.remaining')),
          formatter: this.currencyFormatter,
        },
        {
          key: "used_amount_ratio",
          label: "%",
          thClass: "text-end",
          tdClass: "text-end",
          style: {width: '500'},
        },
        {
          key: "max_days_past_due_in_90_days",
          label: this.lodash.startCase((this.$t('odoo_limit_obligor_groups.dpd_status'))),
        },
      ];
    },
    creatorName() {
      let name = this.model.creator?.name
      if (!name) return '-'
      return name
    },
    updaterName() {
      let name = this.model.updater?.name
      if (!name) return '-'
      return name
    },
    activeTab() {
      const active = this.segmentedButtons.filter((button) => button.active);
      if (active.length) {
        return active?.[0].value;
      }
      return false;
    },
    totalPerson() {
      let total = 0;
      total += [...this.model.addresses, ...this.model.farms].reduce(
          (curr, address) => {
            return curr + (address?.total_person || 0);
          },
          total
      );

      return total;
    },
    odooPartnerName() {
      return this.model.odoo_res_partner?.name ?? '-'
    },
    farms() {
      return this.model.farms || [];
    },
  },
  methods: {
    daysPastDueVariant,
    usedAmountRatioVariant,
    currencyFormatter(value) {
      return this.numeral(value).format("$ 0,0.[00]")
    },
    percentageFormatter(value) {
      return this.numeral(value).format("0.[00]%")
    },
    delete() {
      return this.$axios.delete(`/customers/${this.$route.params.key}`);
    },
    fetchModel() {
      this.loading = true;
      return this.$axios
          .get(`/v1/customers/${this.$route.params.key}`, {
            params: {
              include: [
                "addresses",
                "bank_accounts.bank",
                "odoo_res_partner",
                "creator",
                "farms",
                "updater",
              ].join(','),
            },
          })
          .then((response) => {
            const {
              data: {data},
            } = response;

            const addresses = {};
            ["partner", "lcs", "brs", "processing"].map((customer_type) => {
              const address =
                  data.addresses.find((item) => item.type == customer_type) || {};
              addresses[customer_type] = {
                latitude: null,
                longitude: null,
                total_person: null,
                ...address,
                get coordinate() {
                  return address.latitude
                      ? `${address.latitude},${address.longitude}`
                      : null;
                },
                set coordinate(value) {
                  if (value) {
                    const [lat, lng] = (value || "").split(",");
                    if (
                        lat != null &&
                        Number(lat) &&
                        lng != null &&
                        Number(lng)
                    ) {
                      address.latitude = Number(lat);
                      address.longitude = Number(lng);
                    }
                  } else {
                    address.latitude = null;
                    address.longitude = null;
                  }
                },
              };
            });

            const farms = (data.farms || []).map((farm) => ({
              ...farm,
              get coordinate() {
                return farm.latitude
                    ? `${farm.latitude},${farm.longitude}`
                    : null;
              },
              set coordinate(value) {
                if (value) {
                  const [lat, lng] = (value || "").split(",");
                  if (lat != null && Number(lat) && lng != null && Number(lng)) {
                    farm.latitude = Number(lat);
                    farm.longitude = Number(lng);
                  }
                } else {
                  farm.latitude = null;
                  farm.longitude = null;
                }
              },
            }));

            this.model = {
              ...data,
              ...addresses,
              farms,
            };
            const buttons = this.model.types.map((customer_type) => ({
              text: this.$t(`customers.types.${customer_type}`),
              value: customer_type,
            }));
            buttons[0].active = true;
            this.$set(this, "segmentedButtons", buttons);
            return response;
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => (this.loading = false));
    },
    segmentedButtonLabelFormat(value, label) {
      return value === "farmer" && this.model.farms?.length
          ? `${label} (${this.model.farms.length})`
          : label;
    },
    tabExists(value) {
      return (
          this.segmentedButtons.filter((button) => button.value == value).length >
          0
      );
    },
    onStatusChange(event) {
      this.handleUpdate({
        active: event,
      });
    },
    onBackActiveChange(bank) {
      this.handleUpdate(
          {
            id: bank.id,
            active: bank.active,
          },
          (value) => {
            return this.$axios.put(`/bank_accounts/${value.id}`, {...value});
          }
      );
    },
    handleUpdate(value, updateHandler = this.update) {
      this.updating = true;
      updateHandler(value)
          // .then(() => this.updateSuccessAlert(this.getModelName()))
          .then(() => {
            this.isEditing = false;
            return this.$toast("Perubahan berhasil disimpan", {
              type: "success",
              timeout: 10000,
            });
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => {
            this.updating = false;
          });
    },
    update(value) {
      return this.$axios.put(`/customers/${this.$route.params.key}`, {
        ...value,
      });
    },
    updateSuccessAlert(something) {
      return Swal.fire({
        title: this.$t("Success") + "!",
        text: this.$t(`You've updated {something}`, {something}),
        type: "success",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    failedAlert() {
      return this.$toast("Perubahan gagal disimpan", {
        type: "error",
        icon: {
          iconClass: "mdi mdi-close-circle toast-icon text-danger",
        },
        timeout: 10000,
      });
      // if (error.response && error.response.status === 422) {
      //   this.errors = (error.response.data || {}).errors || {};
      //   const key = Object.keys(this.errors).find((k) => this.errors[k].length)
      //   const errorMessage = key && this.errors[key][0]
      //   return Swal.fire({
      //     title: this.$t('Failed') + '!',
      //     text: errorMessage || (error.response && (error.response.data || {}).message) || error.message,
      //     type: 'danger',
      //     confirmButtonClass: 'btn btn-danger btn-fill',
      //     buttonsStyling: false
      //   })
      // }
      // return Swal.fire({
      //   title: this.$t('Failed') + '!',
      //   text: (error.response && (error.response.data || {}).message) || error.message,
      //   type: 'danger',
      //   confirmButtonClass: 'btn btn-danger btn-fill',
      //   buttonsStyling: false
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .preloader-component {
    background-color: #ffffff;
  }
}

.container-title {
  margin-top: 10px;
  font-family: Lato;
  font-size: 12px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.05em;
  text-align: left;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-family: "Lato";
  color: #6c7589;
}

.custom-group {
  margin-bottom: 30px;
}

.custom-title {
  font-weight: 800;
  font-size: 12px;
  color: #6C7589
}

.custom-label,
.custom-text {
  font-family: Lato;
  font-size: 14px;

  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

.custom-label,
.label {
  font-size: 13px;
  font-weight: 700;
  color: #161b4d;
  text-transform: capitalize;
  margin-bottom: 4px;
}

.custom-text,
.value {
  font-size: 14px;
  font-weight: 400;
  color: #171717;
  margin-bottom: 16px;
}

.section-title {
  background-color: #f9fafb;
  color: #161b4d;
  padding: 14px 21px;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
  border: 1px solid #ececf2;
}

.section-title:first-of-type {
  border-top: none;
}

.section-body {
  padding: 14px 20px;

  .section-label,
  .section-value {
    font-family: Lato;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }

  .section-label {
    color: #161b4d;
    font-weight: 400;
  }

  .section-value {
    color: #161b4d;
    font-weight: 700;
    text-align: right;
  }

  .section-row {
    padding: 6px 0;
  }
}

.sale-item-thead {
  color: #161b4d;
  background-color: #f9fafb;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
}

.sale-item-tbody {
  color: #161b4d;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

::v-deep .page-content {
  background: #eef3f7;
}

$badge-background-primary: rgba(198, 239, 255, 0.3);
$badge-color-primary: #0084f3;
$badge-background-warning: #fff8e7;
$badge-color-warning: #ff9d0b;
$badge-background-danger: #FEE4E2;
$badge-color-danger: #B42318;
$badge-background-success: #DCFCE7;
$badge-color-success: #15803D;
$badge-background-neutral: #98A2B3;
$badge-color-neutral: #000000;

.badge-container {
  &-base {
    background: $badge-background-primary;

    .stakeholder {
      color: #161b4d;
      font-weight: 700;
      font-size: 14px;
    }

    .name {
      font-weight: 700;
      font-size: 20px;
    }
  }

  &-primary {
    @extend .badge-container-base;

    .name {
      color: $badge-color-primary;
    }
  }

  &-warning {
    @extend .badge-container-base;
    background: $badge-background-warning;

    .name {
      color: $badge-color-warning;
    }
  }

  &-danger {
    @extend .badge-container-base;
    background: $badge-background-danger;

    .name {
      color: $badge-color-danger;
    }
  }

  &-success {
    @extend .badge-container-base;
    background: $badge-background-success;

    .name {
      color: $badge-color-success;
    }
  }

  &-neutral {
    @extend .badge-container-base;
    background: $badge-background-neutral;

    .name {
      color: $badge-color-neutral;
    }
  }
}

.badge {
  width: fit-content;
  padding: 3px 6px;
  font-weight: 400;
  font-size: 12px;
  border-radius: 6px;

  &-base {
    background: $badge-background-primary;
  }

  &-primary {
    @extend .badge-container-base;
    color: $badge-color-primary;
  }

  &-warning {
    @extend .badge-container-base;
    background: $badge-background-warning;
    color: $badge-color-warning;
  }

  &-danger {
    @extend .badge-container-base;
    background: $badge-background-danger;
    color: $badge-color-danger;
  }

  &-success {
    @extend .badge-container-base;
    background: $badge-background-success;
    color: $badge-color-success;
  }

  &-neutral {
    @extend .badge-container-base;
    background: $badge-background-neutral;
    color: $badge-color-neutral;
  }
}

::v-deep {
  .badge {
    border-radius: 6px;
    padding: 3px 2px;

    &.badge-success {
      background-color: #DCFCE7 !important;
      color: #15803D !important;
    }

    &.badge-danger {
      background-color: #FEE2E2 !important;
      color: #DC2626 !important;
    }

    &.badge-warning {
      background-color: #FEF0C7 !important;
      color: #DC6803 !important;
    }

    &.badge-dark {
      background-color: #182230 !important;
      color: white !important;
    }

    &.badge-light {
      background-color: #f8f9fa !important;
      color: black !important;
    }
  }
  .overflow-hidden {
    overflow: hidden !important;
  }

  table {
    thead {
      background: #f9fafb !important;
    }
  }

  .custom-switch {
    .custom-control-input:checked {
      background-color: #4cb244;
      border-color: #4cb244;
    }

    .custom-control-input:focus ~ .custom-control-label::before {
      border-color: #4cb244 !important;
      box-shadow: 0 0 0 0.2rem rgba(255, 47, 69, 0.25) !important;
    }

    .custom-control-input:checked ~ .custom-control-label::before {
      border-color: #4cb244 !important;
      background-color: #4cb244 !important;
    }

    .custom-control-input:active ~ .custom-control-label::before {
      background-color: #4cb244 !important;
      border-color: #4cb244 !important;
    }

    .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
      border-color: #4cb244 !important;
    }

    .custom-control-input-green:not(:disabled):active
    ~ .custom-control-label::before {
      background-color: #4cb244 !important;
      border-color: #4cb244 !important;
    }
  }

  .border-tab-content {
    border: 1px solid #D0D5DD;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .nav-address {
    border-bottom: 0;

    .nav-item {
      .nav-link {
        background-color: white;
        color: #182230;
        font-weight: 600;
        font-size: 14px;
        border: 0 solid #D0D5DD;
        border-top-width: 1px;
        border-bottom-width: 2px;
        border-radius: 0px;

        &.active, &:hover, &:focus {
          color: #1664D8;
          border-bottom-color: #1664D8;
        }
      }

      &:first-of-type {
        .nav-link {
          border-left-width: 1px;
          border-top-left-radius: 8px;
        }
      }

      &:last-of-type {
        .nav-link {
          border-right-width: 1px;
          border-top-right-radius: 8px;
        }
      }
    }
  }
}

.section-label {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0084f3;
}

.label-auditable {
  color: rgb(108, 117, 137);
  font-weight: 400;
}
</style>
